import type { orderDetailResource, orderResource } from '@porotutu/api/features/crm/orders/resource'
import { exportHrefFor, unwrap } from '@porotutu/react/api'
import type { ListMeta, ListQuery } from '@porotutu/react/paging'
import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import { crm } from '@/api/client'
import { ORDERS } from '@/api/keys'
import type { CrmOrderSort, OrderStatus } from '../vocabulary'

export type Order = ReturnType<typeof orderResource>

export type OrderDetail = ReturnType<typeof orderDetailResource>

export type OrderPage = { data: Order[]; meta: ListMeta }

export type OrderItem = OrderDetail['items'][number]

export type OrderListQuery = ListQuery<CrmOrderSort, OrderStatus> & { customer_id?: string }

export const ordersQuery = (query: OrderListQuery) =>
  queryOptions({
    queryKey: [...ORDERS, 'list', query] as const,
    queryFn: async () => unwrap(await crm.orders.get({ query })),
    placeholderData: keepPreviousData,
    staleTime: 15_000,
  })

export const orderQuery = (id: string) =>
  queryOptions({
    queryKey: [...ORDERS, 'record', id] as const,
    queryFn: async () => unwrap(await crm.orders({ id }).get()),
    staleTime: 30_000,
  })

export const exportHref = exportHrefFor<OrderListQuery>('/api/v1/crm/orders/export', {
  always: ['customer_id'],
  viewed: ['status', 'search'],
})
